module.exports = __webpack_public_path__ + "static/media/bi.f857b588.png";